export enum FlexWorkerLevelFilters {
  ALL = 'ALL',
  INCOMPLETE = 'INCOMPLETE',
  STARTER = 'STARTER',
  EXPLORER = 'EXPLORER',
  CANDIDATE = 'CANDIDATE',
  WORKER = 'WORKER',
  COMPLETE = 'COMPLETE',
}

export type GetWorkerBaseParamsType = {
  verified?: boolean;
  level?: FlexWorkerLevelFilters;
};

export type GetWorkerByWorkerIdParams = {
  workerId: string;
} & GetWorkerBaseParamsType;

export type GetWorkerByWorkerIdResponse = {
  email: string;
  firstName: string;
};
